import {
  Avatar,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { getAppointments } from "../API/AppointmentsApi";
import AuthContext from "../Context/AuthProvider";
import { getFacilityUsers } from "../API/UsersApi";
import { getDisplayValue } from "../Utility/Utility";
import { AppointmentStatus } from "../Utility/Constants";
import dayjs from "dayjs";
import { ShowChart } from "@mui/icons-material";
import { getServices } from "../API/LinkedServicesApi";
import { convertDateTimeToFacilityTimeZone, convertToUTC, convertUTCToTimeZone } from "../Utility/DateTimeUtility";

const TodayQueue = () => {
  const [selectedPhysicianId, setSelectedPhysicianId] = useState();
  const [physicians, setPhysicians] = useState();
  const [queueList, setQueueList] = useState();
  const {auth} = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState();
  const [waiting, setWaiting] = useState(false);  

  

  useEffect(() => {
    const getPhysiciansList = async () => {
      setErrorMessage();
      var userFilter = {};
      userFilter.facilityId = auth.selectedFacility.id;
      userFilter.roles = ["Physician"];
      var userResults = await getFacilityUsers(auth, userFilter);
      if (userResults?.isSuccess) {
        setPhysicians(userResults?.data);
      }
      else
      {
        setErrorMessage(userResults?.data);
      }

    };

    getPhysiciansList();
  }, [auth]);

  const fetchData = async (physicianId) => {
    setErrorMessage();
    if (physicianId) {
      const filters = {};
      filters.from = convertToUTC(dayjs().set('hour',0).set('minute', 0).set('second', 0).set('millisecond', 0));
      filters.to = convertToUTC(dayjs().set('hour',23).set('minute', 59).set('second', 59).set('millisecond', 999));
      filters.status = ["NotStarted"];
      filters.physicianId = physicianId;
      var result = await getServices(auth, filters);
      //result?.data?.sort()
      if (result.isSuccess) {
        setQueueList(result?.data);
      }
      else
      {
        setErrorMessage(result?.data);
      }
    }
  };

  return (
    <Card
      item
      xs={12}
      variant="outlined"
      sx={{ height: "100%", width: "100%" }}
    >
      <Grid2 container size={12} sx={{ justifyContent: "center" }}>
        <Typography variant="h5">Today's Queue</Typography>
      </Grid2>
      <Divider />
      <Grid2
        container
        size={12}
        sx={{ justifyContent: "center", padding: "10px" }}
      >
        <FormControl fullWidth>
          <InputLabel>Select Physician</InputLabel>
          <Select
            label="Select Physician"
            value={selectedPhysicianId}
            //defaultValue={physicians?.length > 0?physicians[0].id : ""}
            onChange={(e) => {
              setSelectedPhysicianId(e.target.value);
              fetchData(e.target.value);
            }}
          >
            {physicians?.map((i) => (
              <MenuItem value={i.id}>
                {i?.salutation} {i?.firstName} {i?.lastName}, {i?.suffix}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
      <Grid2
        container
        size={12}
        sx={{
          justifyContent: "center",
          paddingX: "10px",
          height: "100%",
          paddingBottom: "5px",
        }}
      >
        <Grid2
          sx={{ height: "100%", width: "100%", }}
        >
          {selectedPhysicianId ? (
          (queueList?.length > 0 ? (queueList?.map((i, index) => (
            <Tooltip title={getDisplayValue(i?.visitStatus)}>
            <Card variant='outlined' sx={{marginTop:"2px"}}>
              
              <Grid2 container size={12} spacing={5} sx={{padding:"5px", alignItems:'center'}}>
                <Grid2 size={2} ><Avatar sx={{backgroundColor:i?.visitStatus === AppointmentStatus.CheckedIn && 'primary.main', }}>
                  {index+1}
                </Avatar></Grid2>
                <Grid2 size={10} sx={{overflow:'hidden'}}>
                  <Typography>{i?.patientFirstName}&nbsp;{i?.patientLastName}</Typography>
                  <Typography variant='body1' fontStyle='italic'>
                    {i?.serviceName}&nbsp;at&nbsp;
                    {convertUTCToTimeZone(i?.scheduledDateTime, auth?.selectedFacility?.timeZone).format("hh:mm A")}
                  </Typography>
                </Grid2>
              </Grid2>
            </Card>
            </Tooltip>
          ))):(
            <Typography>No items are scheduled.</Typography>
          ))):(
            <Typography>Select a physician to view the queue.</Typography>
          )}
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default TodayQueue;
